import { Component, OnInit } from '@angular/core';
import { Partner } from '../../../models/partner';
import { ActivatedRoute } from '@angular/router';
import { PartnerService } from '../../../services/partner.service';

@Component({
  selector: 'app-partner-details',
  templateUrl: './partner-details.component.html',
  styleUrls: ['./partner-details.component.scss']
})
export class PartnerDetailsComponent implements OnInit {

  partner: Partner;

  constructor(private route: ActivatedRoute, private partnerService: PartnerService) { }

  ngOnInit():void {

    //track the selected partner from the service file
    this.partnerService.selectedPartner$.subscribe((x) => {
      this.partner = x;
    });
  }

}
